<template>
	<div>
		<form-sidebar>
			<v-form>
				<v-layout wrap>
					<v-flex xs12>
						<BaseInput
						:height="38"
						label="Código"
						v-model="$v.model.code.$model"
						/>
					</v-flex>
					<v-flex xs12>
						<BaseInput
						:height="38"
						label="Nombre"
						v-model="$v.model.name.$model"
						></BaseInput>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						@cancel-button-clicked="$emit('close-modal')"
						@accept-button-clicked="submitForm"
						:is-loading="disableButton"
					>
					</modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import BaseInput from '@/components/shared/inputs/base-input';
import { required } from 'vuelidate/lib/validators';

function data() {
	return {
		isLoading: false,
		model: {
			code: '',
			moduleId: null,
			name: '',
		},
		modules: [],
	};
}

function createDefinitionModel({ model, customerId, isEditing, subsidiaryId }) {
	const newDefinition = {
		name: model.name,
		code: model.code,
	};
	if (!isEditing) {
		newDefinition.customerId = customerId;
		newDefinition.subsidiaryId = subsidiaryId;
	}
	return newDefinition;
}

async function created() {
	const requests = [];
	if (this.mode.isEditing) {
		requests.push(this.$http.get(`type-register-details/${this.id}`));
	}
	const [module] = await Promise.all(requests);
	if (module) {
		this.model = {
			code: module.data.code,
			name: module.data.name,
		};
	}
}

function disableButton() {
	return this.$v.$invalid || this.loading;
}

function mode() {
	const isEditing = Boolean(this.id);
	return {
		isEditing,
		method: isEditing ? 'patch' : 'post',
		message: isEditing ? 'actualizado' : 'registrado',
		url: isEditing ? `type-register/${this.id}` : 'type-register',
	};
}

async function submitForm() {
	this.isLoading = true;
	const definition = createDefinitionModel({
		customerId: this.customerId,
		isEditing: this.mode.isEditing,
		model: this.model,
		subsidiaryId: this.subsidiaryId,
	});
	try {
		await this.$http[this.mode.method](this.mode.url, definition);
		this.$emit('close-modal', true);
		this.showNotification(`Módulo ${this.mode.message} correctamente`);
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		} else if (error.status === 400) {
			if (error.data.message === 'CODE_MODULE_DUPLICATE') {
				this.showNotification('Código del módulo ya existente.', 'error');
			}
		}
	} finally {
		this.isLoading = false;
	}
}

function validations() {
	const validation = {
		model: {
			name: {
				required,
			},
			code: {
				required,
			},
		},
	};
	return validation;
}

export default {
	name: 'modules-form',
	created,
	computed: {
		disableButton,
		mode,
	},
	components: {
		BaseInput,
	},
	data,
	methods: {
		submitForm,
	},
	props: {
		customerId: {
			type: Number,
			required: true,
		},
		id: {
			type: Number,
			default: null,
		},
		subsidiaryId: {
			type: Number,
			required: true,
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/modules/modules-form.vue